// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"71ccf4b2","436":"d15f637a","653":"8e085aa5","673":"d2bfc0eb","756":"d953e55b","780":"6670219e","825":"77000c57","842":"ba6dd6ec"}[chunkId] + ".css";
};